import {Component} from '@angular/core';

@Component({
  selector: 'id37-modal-backdrop',
  templateUrl: './modal-backdrop.component.html',
  styleUrls: ['./modal-backdrop.component.scss']
})
export class ModalBackdropComponent {
}
